import React from 'react';
import classNames from 'classnames';
import AnchorLink from '@/components/TableOfContents/AnchorLink';
import ContentfulRichText from '@/components/ContentfulRichText/ContentfulRichText';
import {
  bgColorMap,
  paddingTopSizeMap,
  paddingBotSizeMap,
} from '@/utils/styleHelpers';
import { ILink, RichTextObject } from '@/utils/common.types';

interface Props {
  anchorTagRef?: string;
  includeCardShadow?: boolean;
  includeSegment?: boolean;
  backgroundColorTw?: string;
  json: RichTextObject;
  links: ILink;
  linkStyle?: string;
  paragraphStyle?: string;
  paddingTop?: string;
  paddingBottom?: string;
}

const InformationCard = ({
  json,
  links,
  linkStyle,
  paragraphStyle,
  anchorTagRef,
  includeCardShadow = false,
  includeSegment = false,
  backgroundColorTw = 'default',
  paddingTop = '',
  paddingBottom = '',
}: Props) => {
  const description = { json, links, linkStyle, includeSegment };

  return (
    <section
      className={classNames(
        'mx-auto my-[57px] w-mobile md:max-w-standard',
        { [bgColorMap(backgroundColorTw)]: backgroundColorTw },
        { ['shadow-component']: includeCardShadow },
        {
          [paddingTopSizeMap(paddingTop)]: paddingTop,
        },
        {
          [paddingBotSizeMap(paddingBottom)]: paddingBottom,
        }
      )}
    >
      {anchorTagRef && <AnchorLink anchorTagRef={anchorTagRef} />}
      <section
        className={classNames(
          'mx-auto my-0 w-mobile',
          `${paragraphStyle === 'left' ? 'text-left' : 'text-center'}`
        )}
        id={anchorTagRef && `anchortag-${anchorTagRef}`}
      >
        {description && (
          <div className={classNames('w-full text-hbg-blue')}>
            {ContentfulRichText({ ...description })}
          </div>
        )}
      </section>
    </section>
  );
};

export default InformationCard;